import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import ScrollableAnchor from '../../anchor/ScrollableAnchor';

class AccordionTabs extends Component {
  state = {
    visitedTabs: []
  };

  constructor(props) {
    super(props);
    this.state.visitedTabs = new Set([props.activeTabId]);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      visitedTabs: new Set([...prevState.visitedTabs, nextProps.activeTabId])
    };
  }

  updateElementYOffset = () => {
    if (this.props.onUpdateElementYOffsetUpdate) {
      this.props.onUpdateElementYOffsetUpdate(this.props.activeTabId);
    }
  };

  render() {
    const { tabs, activeTabId, toggle } = this.props;

    if (!tabs || !tabs.length) {
      return null;
    }

    return (
      <div className="AccordionTabs">
        {tabs.map((tab) => {
          const isOpen = activeTabId === tab.id;
          return (
            <div
              className={classNames('AccordionTabs__tab', {
                'AccordionTabs__tab--open': isOpen
              })}
              key={tab.id}
            >
              <div
                className="AccordionTabs__tab-toggle"
                onClick={() => toggle(tab.id)}
              >
                <ScrollableAnchor
                  id={tab.id}
                  offset={15}
                  className="AccordionTabs__tab-anchor"
                  scrollIfInHash={false}
                />
                {tab.title}
                <Icon
                  className="AccordionTabs__tab-toggle-icon"
                  name="angle-up"
                />
              </div>
              <Collapse onExited={this.updateElementYOffset} isOpen={isOpen}>
                <div className="AccordionTabs__tab-content">
                  {tab.getContent({
                    preloadOnly: !this.state.visitedTabs.has(tab.id)
                  })}
                </div>
              </Collapse>
            </div>
          );
        })}
      </div>
    );
  }
}

AccordionTabs.propTypes = {
  activeTabId: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  onUpdateElementYOffsetUpdate: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.node.isRequired,
      getContent: PropTypes.func.isRequired
    })
  ).isRequired
};

export default AccordionTabs;



// WEBPACK FOOTER //
// ./src/components/common/AccordionTabs/index.jsx